






import { Component, Vue } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
import { Getter } from "vuex-class";
@Component
export default class App extends Vue {
  loadingText: string = MESSAGE.Loading;
  isUserMode: boolean = false;

  @Getter("fontSizeLevel", { namespace: "GlobalValue" })
  fontSizeLevelVal: number;

  created() {
    setTimeout(() => {
      if (this.$route.fullPath.indexOf("user") > -1) {
        this.isUserMode = true;
      }

      let refer: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      if (this.isUserMode) {
        refer.href = window.location.origin + "/favicon2.ico";
      } else {
        refer.href = window.location.origin + "/favicon1.ico";
      }
      /** 2021-07-06 sh #7265 set to title. [START] */
      document.title = '車検PRO';
      if (process.env.VUE_APP_API_URL === 'https://staging-inspection.extreme-service.jp/skn/v1') {
        document.title = '【Staging】車検PRO';
      }
      if (process.env.VUE_APP_API_URL === 'https://test-inspection.extreme-service.jp/skn/v1') {
        document.title = '【検証】車検PRO';
      }
      if (process.env.VUE_APP_API_URL === 'http://localhost:18802/skn/v1') {
        document.title = '【開発】車検PRO';
      }
      /** 2021-07-06 sh #7265 set to title. [END] */
    }, 750);
  }

  get cssFontSize() {
    if (this.fontSizeLevelVal == 1) {
      return "s";
    }
    if (this.fontSizeLevelVal == 3) {
      return "l";
    }

    return "";
  }
}
